export default [
  { shop_id: "5e9412e0b2bfbc089daerr10", shop_name: "驯养中心" },
  { shop_id: "5e9412e0b2bfbc089daerr11", shop_name: "小程序店" },
  { shop_id: "5e9412e0b2bfbc089daerr12", shop_name: "金水区店" },
  { shop_id: "5e9412e0b2bfbc089daerr14", shop_name: "指挥中心" },
  // { shop_id: "5e9412e0b2bfbc089daerr17", shop_name: "线上旗舰店" },
  { shop_id: "5e9412e0b2bfbc089daerr18", shop_name: "郑东新区店" },
];
